import { Identify, identify, Types, setUserId, track } from '@amplitude/analytics-browser'

import getFeatureFlag from '../actions/get-feature-flag'
import { SURVEY_CATEGORY } from '../types/global.types'

export enum AMP_EVENT_NAME {
  VIEW_SURVEY_LIST = 'View Survey List',
  VIEW_SURVEY_DETAIL = 'View Survey Detail',
  START_SURVEY = 'Start Survey',
  COMPLETE_SURVEY = 'Complete Survey',
  VIEW_SUBMISSION_HISTORY = 'View Submission History',
  START_WITHDRAW_REWARDS = 'Start Withdraw Rewards',
  COMPLETE_WITHDRAW_REWARDS = 'Complete Withdraw Rewards',
  ANSWER_SURVEY_QUESTION = 'Answer Survey Question',
  VIEW_REWARDS = 'View Rewards',
  LOG_OUT = 'Log Out',
  VIEW_NOTIFICATION_LIST = 'View Notification List',
  CLICK_NOTIFICATION = 'Click Notification',
  VIEW_PUSH_NOTIFICATION_PROMPT = 'View Push Notification Prompt',
  CLICK_PUSH_NOTIFICATION_PROMPT = 'Click Push Notification Prompt',
  CLICK_PUSH_NOTIFICATION = 'Click Push Notification',
  CLICK_HELP_CENTER = 'Click Help Center',
}

export enum LOGIN_METHOD {
  EMAIL = 'Email',
  PHONE_NUMBER = 'Phone Number',
}

export interface TPropertyName {
  'Survey ID'?: string
  'Survey Category'?: SURVEY_CATEGORY
  'Total Question'?: number
  'Withdrawal Method'?: string
  'Withdrawal Account Type'?: string
  'Withdrawal Amount'?: number
  'Login Method'?: LOGIN_METHOD
  'Total Survey Available'?: number
  'Curent Question Number'?: number
  'Notification Type'?: string
  'Notification Title'?: string
}

export enum UserProperty {
  FULL_NAME = 'Full Name',
  PHONE_NUMBER = 'Phone Number',
  TOTAL_SURVEY_COMPLETED = 'Total Survey Completed',
  PARTNER_ID = 'Partner ID',
}

const isAmplitudeEnabled = async (): Promise<boolean> => {
  return await getFeatureFlag('enableAmplitude')
}

export const setUserAttr = async (
  property: UserProperty,
  value: Types.ValidPropertyType,
  setOnce = false,
) => {
  const identifyEvent = new Identify()
  const amplitudeEnabled = await isAmplitudeEnabled()

  if (!amplitudeEnabled) {
    return null
  }

  setOnce ? identifyEvent.setOnce(property, value) : identifyEvent.set(property, value)
  identify(identifyEvent)
}

export const unsetUserAttr = async (property: UserProperty) => {
  const identifyEvent = new Identify()
  const amplitudeEnabled = await isAmplitudeEnabled()

  if (!amplitudeEnabled) {
    return null
  }

  identifyEvent.unset(property)
  identify(identifyEvent)
}

export const setAmplitudeUserId = async (id: string | undefined) => {
  const amplitudeEnabled = await isAmplitudeEnabled()

  if (!amplitudeEnabled) {
    return null
  }

  setUserId(id)
}

export const trackAmpEvent = async <T>(
  eventName: AMP_EVENT_NAME,
  eventProperties?: TPropertyName & T,
  eventOptions?: Types.EventOptions,
) => {
  const amplitudeEnabled = await isAmplitudeEnabled()

  if (!amplitudeEnabled) {
    return null
  }

  track(eventName, eventProperties, eventOptions)
}
